import React, { useMemo } from "react";
import RfmListView from "./RfmListView";
import RfmZoomControls from "./RfmZoomControls";
import RfmGridView from "./RfmGridView";

export default function RfmFloor({
    zones = [],
    tables = [],
    objects = [],
    statuses = [],

    currentZone = "all",
    activeZone = null,

    zoomLevel = 1,
    editMode = false,

    onOpenModal,
    onSelectTable,
    onEventsSeen,
    onChargePosPayment,
    onReviewDiscounts,

    onZoomChange,
    onToggleEditMode,

    onCellClick,
    onSelectObject,
    onMoveObject,
    onMoveTable,

    selectedTableId,
    selectedObjectId,

    onCreateTableAt,

    updateTable,
    updateObject,
}) {
    const title = useMemo(() => {
        if (currentZone === "all") return "Todas las Mesas";
        const z = zones.find((x) => x.id === currentZone);
        return z?.name || "Zona";
    }, [currentZone, zones]);

    return (
        <div className="">
            <div className="rfm-floor-header">
                <h2 className="rfm-floor-title">{title}</h2>
                <div className="rfm-floor-actions">
                    {currentZone !== "all" ? (                        <>
                            <RfmZoomControls zoomLevel={zoomLevel} onChange={(z) => onZoomChange?.(z)} />
                            <button
                                className="rfm-btn rfm-btn-secondary rfm-btn-icon"
                                type="button"
                                title="Agregar objeto"
                                onClick={() => onOpenModal?.("create-object")}
                            >
                                <i className="bi bi-bounding-box" />
                            </button>


                            <button
                                className="rfm-btn rfm-btn-secondary rfm-btn-icon"
                                type="button"
                                title="Modo edición"
                                style={editMode ? { background: "var(--accent-primary)", color: "white" } : undefined}
                                onClick={() => onToggleEditMode?.()}
                            >
                                <i className="bi bi-arrows-move" />
                            </button>

                            <button
                                className="rfm-btn rfm-btn-secondary rfm-btn-icon"
                                type="button"
                                title="Editar zona"
                                onClick={() => onOpenModal?.("edit-zone")}
                            >
                                <i className="bi bi-pencil-square" />
                            </button>

                            <button
                                className="rfm-btn rfm-btn-danger rfm-btn-icon"
                                type="button"
                                title="Eliminar zona"
                                onClick={() => onOpenModal?.("delete-zone")}
                            >
                                <i className="bi bi-trash" />
                            </button>
                        </>
                    ) : null}
                </div>
            </div>

            <div className="rfm-floor-container">
                {currentZone === "all" ? (
                    <RfmListView tables={tables} zones={zones} statuses={statuses} onSelectTable={onSelectTable} onEventsSeen={onEventsSeen} onChargePosPayment={onChargePosPayment} onReviewDiscounts={onReviewDiscounts} />
                ) : (
                    <div style={{ padding: 16 }}>
                        <RfmGridView
                            zone={activeZone}
                            tables={tables}
                            objects={objects ?? []}
                            statuses={statuses}
                            editMode={editMode}
                            zoomLevel={zoomLevel}
                            selectedTableId={selectedTableId}
                            selectedObjectId={selectedObjectId}
                            onCellClick={onCellClick}
                            onSelectTable={onSelectTable}
                            onSelectObject={onSelectObject}
                            onMoveTable={onMoveTable}
                            onMoveObject={onMoveObject}
                            updateTable={updateTable}
                            updateObject={updateObject}
                            onCreateTableAt={onCreateTableAt}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
